import { render } from "./Credenciamento.vue?vue&type=template&id=69c784a1&scoped=true"
import script from "./Credenciamento.vue?vue&type=script&lang=js"
export * from "./Credenciamento.vue?vue&type=script&lang=js"

import "./Credenciamento.vue?vue&type=style&index=0&id=69c784a1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69c784a1"]])

export default __exports__